<template>
	<div>
		<div class="banner">
			<div class="title">
				<div class="backColor"></div>
				<div class="overlay">加 速 创 新 · 赋 能 云 网 边</div>
			</div>
		</div>

		<div class="container">
			<div class="leftRight"></div>
			<section class="center">
				<div style="color: #4B4B4B;">
					<div class="flex_content" style="margin: 60px 0 0;gap: 30px;">
						<el-radio v-model="radio" label="ZO-SASE" class="title">
							<el-image v-if="radio=='ZO-SASE'" :src="solute1" class="title_img"></el-image>
							<el-image v-else :src="solute2" class="title_img"></el-image>
							<div>ZO-SASE</div>
						</el-radio>
  					<el-radio v-model="radio" label="ZO-Net" class="title">
							<el-image v-if="radio=='ZO-Net'" :src="solute3" class="title_img"></el-image>
							<el-image v-else :src="solute4" class="title_img"></el-image>
							<div>ZO-Net</div>
						</el-radio>
						<el-radio v-model="radio" label="ZO-Cloud" class="title">
							<el-image v-if="radio=='ZO-Cloud'" :src="solute5" class="title_img"></el-image>
							<el-image v-else :src="solute6" class="title_img"></el-image>
							<div>ZO-Cloud</div>
						</el-radio>
					</div>
				</div>
			</section>
			<div class="leftRight"></div>
		</div>

		<div style="margin-bottom: 60px">
			<!-- ZO-SASE -->
			<div v-if="radio == 'ZO-SASE'">
				<!-- 产品介绍 -->
				<div class="container">
					<div class="leftRight"></div>
					<section class="center">
						<div style="color: #4B4B4B;">
							<div class="flex-items-between intro">
								<el-image class="intro_img" :src="introImg1"></el-image>
								<div class="intro_content">
									<div class="vue-flex" style="align-items: center;margin-bottom: 30px;">
										<div class="line"></div>
										<div class="intro_title">ZO-SASE 产品介绍</div>
									</div>
									<div class="intro_dl">
										ZO-SASE是基于SDN和广域网优化技术打造的下一代企业级网络管理平台，可部署于本地（或云端）为企业构建高速连接、安全稳定的网络，为用户提供分支互联和应用加速服务。具备SD-Branch架构，为园区办公提供LAN和WAN的融合；逐步完善ZTNA架构，为混合办公提供网络和安全功能的融合，实现任意时空、环境下的安全边缘访问。
									</div>
								</div>
							</div>
						</div>
					</section>
					<div class="leftRight"></div>
				</div>
	
				<!-- 产品架构 -->
				<div class="container">
					<div class="leftRight"></div>
					<section class="center">
						<div style="color: #4B4B4B;">
							<div class="module_title">ZO-SASE产品架构</div>
							<div class="flex-items-between proarc">
								<el-image class="proarc_img" :src="arcImg1"></el-image>
								<div class="proarc_content">
									<div class="proarc_item" v-for="(item,index) in proarcList" :key="'proarc' + index">
										<div class="proarc_title">{{item.title}}</div>
										<div>{{item.content}}</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<div class="leftRight"></div>
				</div>
	
				<!-- 产品优势 -->
				<div class="container" style="background-color: #F9FAFB;margin-bottom: -60px">
					<div class="leftRight"></div>
					<section class="center">
						<div style="color: #4B4B4B;">
							<div class="module_title">产品优势</div>
							<el-row :gutter="20" style="height: 350px">
								<span v-for="item,index in saseList" :key="index">
									<el-col :span="8" :style="{ marginBottom: '20px' }">
										<div class="product flex_items">
											<el-image class="product_img" :src="item.src"></el-image>
											<div style="width: 450px">
												<div class="product_title">{{item.title}}</div>
												<div class="product_content">{{item.content}}</div>
											</div>
										</div>
									</el-col>
								</span>
							</el-row>
						</div>
					</section>
					<div class="leftRight"></div>
				</div>
			</div>
	
			<!-- ZO-Net -->
			<div v-if="radio == 'ZO-Net'">
				<!-- 产品介绍 -->
				<div class="container">
					<div class="leftRight"></div>
					<section class="center">
						<div style="color: #4B4B4B;">
							<div class="flex-items-between intro">
								<el-image class="intro_img" :src="introImg2"></el-image>
								<div class="intro_content">
									<div class="vue-flex" style="align-items: center;margin-bottom: 30px;">
										<div class="line"></div>
										<div class="intro_title">ZO-Net 产品介绍</div>
									</div>
									<div class="intro_dl">
										ZO-Net是基于国内长途骨干专线、本地专线、IEPL国际电路、海外专线搭建而成的全球私有网络，可为企业各数据节点之间提供专用的私有化互联通道，主要应用于中大型企业用户在不同区域之间的企业组网和数据传输。
									</div>
								</div>
							</div>
						</div>
					</section>
					<div class="leftRight"></div>
				</div>
	
				<!-- 产品架构 -->
				<div class="container">
					<div class="leftRight"></div>
					<section class="center">
						<div style="color: #4B4B4B;">
							<div class="module_title">ZO-Net 产品架构</div>
							<el-image style="width: 100%" :src="arcImg2"></el-image>
						</div>
					</section>
					<div class="leftRight"></div>
				</div>
	
				<!-- 产品优势 -->
				<div class="container">
					<div class="leftRight"></div>
					<section class="center">
						<div style="color: #4B4B4B;">
							<div class="module_title">产品优势</div>
							<div class="vue-flex" style="margin-bottom: 50px">
								<el-image style="width: 42%;margin-right: 50px;box-sizing: border-box;" :src="arcAvg"></el-image>
								<div>
									<div class="netavg" v-for="item,index in netavgList" :key="index">
										{{item.avg}}
									</div>
								</div>
							</div>
							<div class="proavg">国内骨干网时延</div>
							<el-image style="width: 100%" :src="arcAvg1"></el-image>
							<div class="proavg">云接入点（国内）</div>
							<el-image style="width: 100%" :src="arcAvg2"></el-image>
							<div class="proavg">云接入点（海外）</div>
							<el-image style="width: 100%" :src="arcAvg3"></el-image>
						</div>
					</section>
					<div class="leftRight"></div>
				</div>
			</div>
	
			<!-- ZO-Cloud -->
			<div v-if="radio == 'ZO-Cloud'">
				<!-- 哐哐哐 -->
				<div class="container" style="margin-bottom: 50px">
					<div class="leftRight"></div>
					<section class="center">
						<div class="module_title">特惠产品</div>
	
						<div class="preference">
							<div class="buy" v-for="(Item,Index) in productList" :key="'pro' + Index">
								<div>
									<span class="buy_title">{{Item.title}}</span>
									<span class="buy_sub">{{Item.subtitle}}</span>
								</div>
	
								<el-divider></el-divider>
	
								<div class="vue-flex">
									<div v-for="(section, index) in Item.serverSections" :key="index" class="server-section">
										<div v-for="(text, key) in section" :key="key" class="buy_form">
											<span class="buy_label">{{ key }}：</span>
											<span class="buy_value">{{ text }}</span>
										</div>
									</div>
								</div>
	
								<div v-for="(select,index) in selectList" :key="'select' + index" class="vue-flex" style="margin-top: 15px">
									<div class="buy_zd">{{select.name}}</div>
									<el-select v-model="Item[select.value]" filterable clearable placeholder="请选择" style="width: 360px">
										<el-option
												v-for="option in select.options"
												:key="option.value"
												:label="option.label"
												:value="option.value">
										</el-option>
									</el-select>
								</div>
								
								<el-divider></el-divider>
	
								<div class="flex-between">
									<div style="line-height: 36px">
										<span class="price">￥ {{Item.price1[Item.time]}}</span>
										<span>省￥ {{Item.price2[Item.time]}}</span>
									</div>
									<div>
										<el-button type="info" @click="dialogVisible = true">立即购买</el-button>
									</div>
								</div>
							</div>
						</div>
					</section>
					<div class="leftRight"></div>
				</div>
	
				<!-- 产品介绍 -->
				<div class="container">
					<div class="leftRight"></div>
					<section class="center">
						<div style="color: #4B4B4B;">
							<div class="module_title">ZO-Cloud 产品介绍</div>
							<el-image style="width: 100%" :src="introImg3"></el-image>
							<div class="introCloud">
								ZO-Cloud是佐云科技基于OpenStack技术自研开发的公有云平台，具有性价比高、轻量化、高可靠性、海内外节点分布广等优势。具备与全球主流公有云的云端口预连接和云API对接能力，可通过ZO- Net骨干网和CMP多云管理平台为客户提供便捷、灵活的多云互联和统一纳管服务。
							</div>
						</div>
					</section>
					<div class="leftRight"></div>
				</div>
	
				<!-- 产品架构 -->
				<div class="container">
					<div class="leftRight"></div>
					<section class="center">
						<div style="color: #4B4B4B;">
							<div class="module_title" style="margin-bottom: 10px">ZO-Cloud 产品架构</div>
							<el-image style="width: 100%" :src="arcImg3"></el-image>
						</div>
					</section>
					<div class="leftRight"></div>
				</div>
	
				<!-- 技术优势 -->
				<div class="container" style="background-color: #F9FAFB;margin-bottom: -60px">
					<div class="leftRight"></div>
					<section class="center">
						<div style="color: #4B4B4B;">
							<div class="module_title">技术优势</div>
							<el-row :gutter="80" style="height: 350px">
								<span v-for="item,index in cloudList" :key="index">
									<el-col :span="12" :style="{ marginBottom: '30px' }">
										<div class="product_cloud flex_items">
											<el-image class="product_img" :src="item.src"></el-image>
											<div style="width: 450px">
												<div class="product_title">{{item.title}}</div>
												<div class="product_content">{{item.content}}</div>
											</div>
										</div>
									</el-col>
								</span>
							</el-row>
						</div>
					</section>
					<div class="leftRight"></div>
				</div>
			</div>
		</div>		

		<el-dialog :visible.sync="dialogVisible" width=50vw>
				<div class="dialog">产品升级中，敬请期待...</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				radio: this.$route.query.name ? this.$route.query.name : 'ZO-SASE',
				solute1: require('@/assets/produce/icon1.jpg'),
				solute2: require('@/assets/produce/icon2.jpg'),
				solute3: require('@/assets/produce/icon3.jpg'),
				solute4: require('@/assets/produce/icon4.jpg'),
				solute5: require('@/assets/produce/icon5.jpg'),
				solute6: require('@/assets/produce/icon6.jpg'),

				introImg1: require('@/assets/produce/sasepro.jpg'),
				arcImg1: require('@/assets/produce/sasearc.jpg'),
				proarcList: [
					{title: '转控分离', content: '实现网络控制和数据转发的独立分离，提升网络管理灵活性和效率。'},
					{title: '双控制引擎', content: '集成两个独立的控制引擎，确保网络稳定性和高可用性的同时提供更强大的管理能力。'},
					{title: '支持ZTP', content: '支持零接触部署，简化设备部署流程，实现自动化、远程配置。'},
					{title: '多接入场景', content: '支持办公、移动、公有云等接入场景，兼容主流网络协议，保障顺畅连接。'},
				],
				saseList: [
					{ src: require('@/assets/produce/wljg001.jpg'), title: 'ZO-TT广域网优化技术', content: 'ZO-TCP Tunnel，佐云科技自研封装的全链路虚拟加速隧道，支持多种数据安全加密算法' },
					{ src: require('@/assets/produce/wljg002.jpg'), title: '智能选路', content: '可配置的智能流量路由和负载均衡技术，动态选择最佳路径，优化网络性能，保障高优先级应用体验' },
					{ src: require('@/assets/produce/wljg003.jpg'), title: '智能Qos', content: '支持广域网和局域网QoS 优先级策略，可以防止网络拥塞和过载，确保关键应用程序和服务的网络优先级' },
					{ src: require('@/assets/produce/wljg004.jpg'), title: '智能DNS', content: '支持可配置每个线路使用不同的DNS解析服务，实现不同SaaS服务就近解析，还可实现智能分流' },
					{ src: require('@/assets/produce/wljg005.jpg'), title: '支持ZTP部署', content: '支持零接触部署，CPE内置管理LTE网络，无需现场配置，可线上鉴权批量模板化远程配置' },
					{ src: require('@/assets/produce/wljg006.jpg'), title: '支持HA部署', content: '支持高可用部署，通过VRRP，实现无感知的故障转移、负载均衡、简化管理和支持灵活的网络拓扑' },
				],

				introImg2: require('@/assets/produce/netpro.jpg'),
				arcImg2: require('@/assets/produce/netarc.jpg'),

				arcAvg: require('@/assets/produce/netavg.jpg'),
				arcAvg1: require('@/assets/produce/netavg1.jpg'),
				arcAvg2: require('@/assets/produce/netavg2.jpg'),
				arcAvg3: require('@/assets/produce/netavg3.jpg'),
				netavgList: [
					{ avg: 'ZO-Net骨干网底层以三大运营商和中信网络为主，局部接入高速、高铁、广电线路，可提供运营商合规方式，具备完整的端到端一站交付能力。' },
					{ avg: 'ZO-Net在福建、广东具备大量由三大运营商提供的本地裸光纤资源，在其上搭建了波分传输通道，可便捷提供超大带宽的波道传输或电路。' },
					{ avg: 'ZO-Net国内骨干网具备一干、二千OTN波道，本地专线均具备异路由保护，POP均具备双设备&电源，形成一张多设备、多协议、多网、多环、多POP的高可用精品网络，最高可提供99.99%SLA保障级别服务。' },
					{ avg: 'ZO-Net拥有丰富的云网产品线和解决方案团队，从产品组合、网络耦合到平台整合，都可提供丰富的解决方案，满足客户各类定制化需求。' },
					{ avg: '运维工程师核心团队来自三大运营商，拥有丰富的运维经验；ZO-NOC监控平台具备全网可视化、毫秒级实时监控、多平台推送告警、网络智能优化等能力，可提供智能化、高效率的7*24h运维服务。' }
				],
				introImg3: require('@/assets/produce/cloudpro.jpg'),
				arcImg3: require('@/assets/produce/cloudarc.jpg'),
				cloudList: [
					{ src: require('@/assets/produce/wljg007.jpg'), title: '弹性扩展', content: '根据用户的业务需求，随时弹性扩展资源，如CPU、内存、硬盘升级，网络线路切换，一机多IP等' },
					{ src: require('@/assets/produce/wljg008.jpg'), title: '秒级部署', content: '全WEB化操作，支持不同配置，多种操作系统和应用标准镜像供用户选择，实现瞬时供应和部署计算资源' },
					{ src: require('@/assets/produce/wljg009.jpg'), title: '安全可靠', content: '提供多级数据备份与恢复，用户资源互相隔离，不受其他用户影响' },
					{ src: require('@/assets/produce/wljg010.jpg'), title: '高性价比', content: '支持多种计费模式，资源配置成本弹性可控，无后期服务器网络和硬件等维护费用，根据需求制定最优性价比方案' },
				],
				dialogVisible: false,
				productList: [
					{ 
						title: '福建云服务器', 
						subtitle: '适合个人入门', 
						image: 'window9', 
						time: 'onemonth' ,
						serverSections: [
							{
								'CPU': '2核',
								'线路': 'BGP',
								'系统盘': '40GB',
							},
							{
								'内存': '2G',
								'宽带': '2M',
								'数据盘': '容量型 10G',
							},
						],
						price1: {// 折后
							'onemonth': '126.27',
							'threemonth': '378.81',
							'sixmonth': '757.62',
							'oneyear': '1262.7',
							'twoyear': '2525.4',
						},
						price2: {// 省
							'onemonth': '56.73',
							'threemonth': '170.19',
							'sixmonth': '340.38',
							'oneyear': '933.3',
							'twoyear': '1866.6',
						},
					},{ 
						title: '福建云服务器', 
						subtitle: '适合中小企业', 
						image: 'window9', 
						time: 'onemonth',
						serverSections: [
							{
								'CPU': '2核',
								'线路': 'BGP',
								'系统盘': '40GB',
							},
							{
								'内存': '4G',
								'宽带': '2M',
								'数据盘': '容量型 10G',
							},
						],
						price1: {// 折后
							'onemonth': '153.87',
							'threemonth': '461.61',
							'sixmonth': '923.22',
							'oneyear': '1538.7',
							'twoyear': '3077.4',
						},
						price2: {// 省
							'onemonth': '69.13',
							'threemonth': '207.39',
							'sixmonth': '414.78',
							'oneyear': '1137.3',
							'twoyear': '2274.6',
						},
					},{ 
						title: '广东云服务器', 
						subtitle: '适合个人入门', 
						image: 'window9', 
						time: 'onemonth',
						serverSections: [
							{
								'CPU': '2核',
								'线路': 'BGP',
								'系统盘': '40GB',
							},
							{
								'内存': '2G',
								'宽带': '2M',
								'数据盘': '容量型 10G',
							},
						],
						price1: {// 折后
							'onemonth': '126.27',
							'threemonth': '378.81',
							'sixmonth': '757.62',
							'oneyear': '1262.7',
							'twoyear': '2525.4',
						},
						price2: {// 省
							'onemonth': '56.73',
							'threemonth': '170.19',
							'sixmonth': '340.38',
							'oneyear': '933.3',
							'twoyear': '1866.6',
						},
					},{ 
						title: '广东云服务器', 
						subtitle: '适合中小企业', 
						image: 'window9', 
						time: 'onemonth',
						serverSections: [
							{
								'CPU': '2核',
								'线路': 'BGP',
								'系统盘': '40GB',
							},
							{
								'内存': '4G',
								'宽带': '2M',
								'数据盘': '容量型 10G',
							},
						],
						price1: {// 折后
							'onemonth': '153.87',
							'threemonth': '461.61',
							'sixmonth': '923.22',
							'oneyear': '1538.7',
							'twoyear': '3077.4',
						},
						price2: {// 省
							'onemonth': '69.13',
							'threemonth': '207.39',
							'sixmonth': '414.78',
							'oneyear': '1137.3',
							'twoyear': '2274.6',
						},
					},
				],
				selectList: [
					{
						name: '镜像:',
						value: 'image',
						options: [
							{ label: 'Windows Server 2019 数据中心版64位中文版', value: 'window9' },
							{ label: 'Windows Server 2016 数据中心版64位中文版', value: 'window6' },
							{ label: 'Centos7.9 64位', value: 'centos9' },
							{ label: 'Centos7.6 64位', value: 'centos6' },
							{ label: 'Ubuntu Server 22.04 LTS 64位', value: 'ubuntu' },
							{ label: 'Debian 11.4 64位', value: 'debian' },
						]
					},{
						name: '购买时长:',
						value: 'time',
						options: [
							{ label: '1个月', value: 'onemonth' },
							{ label: '3个月', value: 'threemonth' },
							{ label: '半年', value: 'sixmonth' },
							{ label: '一年', value: 'oneyear' },
							{ label: '二年', value: 'twoyear' },
						]
					}
				],
			}
		},
		mounted() {
			
		},
		methods: {
			
		},
	}
</script>

<style scoped  lang="scss">
/* 圣杯布局 */
.container {
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
}
.center {
  flex: 0 0 1200px;
}
.leftRight {
  flex: 1;
}

/* banner图 */
.banner {
  height: 55vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../assets/produce/banner.jpg") no-repeat;
  background-size: cover;// 全覆盖
	background-position: center; //指定元素背景图片的位置  
	.title{
		position: relative;
		.backColor {
			width: 360px;
			height: 46px;
			background-color: rgba(248, 242, 242, 0.2);
			backdrop-filter: blur(5px); /* 调整模糊程度 */
		}
		.overlay {
			position: absolute;
			top: 2px;
			left: 15px;
			color: white;
			font-size: 28px;
			font-weight: 400;
		}
	}
}
// @media (max-width: 1000px) {
//   .banner {
//     background-size: contain;
//   }
// }
// @media (min-width: 1000px) {
//   .banner {
//     background-size: cover;
//     background-position: center center;
//   }
// }

.module_title {
  font-size: 28px;
  font-weight: bold;
  color: #4B4B4B;
  text-align: center;
  margin: 30px 0 40px 0;
}

// radio的设置
.title{
	 text-align: center;
	 line-height: 40px;
	 .title_img{
		// width: 80px;
		height: 60px;
	}
}

.netavg {
	margin: 6px 0 52px;
	line-height: 22px;
}
.netavg:last-child {
	margin:  0 0;
}

// 产品介绍
.intro{
	// margin-bottom: 20px;
	.intro_img{
		width: 45%;
	}
	.intro_content{
		width: 48%;
		// padding: 10px 0 0;
		.line{
			height: 20px;
			width: 2px;
			background-color: #B8E0F4;
			margin-right: 10px;
		}
		.intro_title{
			font-size: 26px;
			font-weight: bold;
		}
		.intro_dl {
			line-height: 26px;
			text-indent: 2em;
		}
	}
}
.introCloud {
	width: 90%;
	margin: 30px auto 0;
	line-height: 26px;
	text-indent: 2em;
}

// 产品架构
.proarc {
	.proarc_img{
		width: 58%;
	}
	.proarc_content{
		width: 36%;
	}
	.proarc_item {
		margin-top: 50px; /* 项目之间的间隔，可以根据需要调整 */
		line-height: 26px;
		.proarc_title {
			font-weight: bold;
		}
	}
	.proarc_item:first-child {
		margin-top: 0px; /* 项目之间的间隔，可以根据需要调整 */
	}
}

// 产品优势
.product{
	background-color: #FFFFFF;
	height: 120px;
	border-radius: 15px;
	padding: 0 25px;
	box-sizing: border-box;
	.product_img{
		margin: 0 15px 0 0;
		width: 50px;
		// height: 62px;
		object-fit: cover; /* 保持图片比例，裁剪不适应的部分 */
	}
	.product_title{
		line-height: 40px;
		margin-top: -10px;
	}
	.product_content{
		font-size: 14px;
		line-height: 18px;
	}
}

.product_cloud {
	background-color: #FFFFFF;
	height: 120px;
	border-radius: 15px;
	padding: 0 35px;
	box-sizing: border-box;
	.product_img{
		margin: 0 30px 0 0;
		// width: 50px;
		height: 65px;
		object-fit: cover; /* 保持图片比例，裁剪不适应的部分 */
	}
	.product_title{
		line-height: 40px;
		margin-top: -10px;
	}
	.product_content{
		font-size: 14px;
		line-height: 18px;
	}
}

.proavg {
	text-align: center;
	font-size: 20px;
	font-weight: bold;
	margin: 20px 0;
}

.preference {
	color: #4B4B4B;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	row-gap: 26px;
}

.buy{
	width: 48%;
	height: 460px;
	box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
	padding: 30px;
	box-sizing: border-box;
	.buy_title{
		font-size: 26px;
		font-weight: 600;
	}
	.buy_sub{
		font-size: 18px;
		margin-left: 15px;
		color: #BFBFBF;
	}
	.server-section {
		margin-right: 80px;
		.buy_form{
			line-height: 40px;
			color: grey;
			.buy_label {
				color: grey;
				display: inline-block;
				width: 80px;
				line-height: 40px;
			}
		}
	}
	.buy_zd{
		color: grey;
		display: inline-block;
		width: 80px;
		line-height: 40px;
	}
}

.price{
	font-size: 20px;
	color: #FF7304;
	margin-right: 10px;
}

.dialog {
	text-align: center;
	font-size: 30px;
	margin-bottom: 40px;
}
</style>

<style scope>
/* 添加用于垂直居中对话框的自定义样式 */
.el-dialog__wrapper {
  display: flex;
  align-items: center;
	margin-top: -80px;
  /* justify-content: center; */
}

/* .el-dialog {
	
} */
.el-avatar, .el-cascader-panel, .el-radio, .el-radio--medium.is-bordered .el-radio__label, .el-radio__label {
  font-size: 24px;
}
.el-radio__inner {
  display: none !important;
}
.el-radio-button:not(:last-child) {
	/* 最后一个不加间距 */
  margin-right: 60px; /* 适当的间距值 */
}
/* .el-radio-button__orig-radio:checked+.el-radio-button__inner {
	
} */
.el-radio-button:first-child .el-radio-button__inner {
	border: none;
}
.el-radio-button__inner{
	border: none;
	/* bborder-radius: 20px;
	padding: 8px 20px; */
	/* background-color: #EEF5FD; */
}
</style>